import { render } from "./location.vue?vue&type=template&id=8bbeb112"
import script from "./location.vue?vue&type=script&lang=js"
export * from "./location.vue?vue&type=script&lang=js"

import "./location.vue?vue&type=style&index=0&id=8bbeb112&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__